"use client"

import { ChessQueen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChessQueenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChessQueenIcon = component(Icon)({ as: ChessQueen })
